import React, { useState } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Shield } from 'lucide-react';
import AdminUsersPage from './AdminUsersPage';
import AdminCompaniesPage from './AdminCompaniesPage';
import AdminModulesPage from './AdminModulesPage';

export default function AdminPage() {
  return (
    <div className="p-8 space-y-8" data-testid="admin-page">
      <div className="flex items-center gap-3">
        <Shield className="h-8 w-8 text-[hsl(var(--accent))]" />
        <div>
          <h1 className="text-3xl font-semibold" style={{ fontFamily: 'var(--font-display)' }}>
            Admin Panel
          </h1>
          <p className="text-[hsl(var(--muted-foreground))]">
            Super admin controls for Maritime Pulse
          </p>
        </div>
      </div>

      <Tabs defaultValue="users" className="space-y-6">
        <TabsList className="grid w-full grid-cols-3">
          <TabsTrigger value="users" data-testid="tab-users">
            User Management
          </TabsTrigger>
          <TabsTrigger value="companies" data-testid="tab-companies">
            Companies
          </TabsTrigger>
          <TabsTrigger value="modules" data-testid="tab-modules">
            Modules
          </TabsTrigger>
        </TabsList>

        <TabsContent value="users">
          <AdminUsersPage />
        </TabsContent>

        <TabsContent value="companies">
          <AdminCompaniesPage />
        </TabsContent>

        <TabsContent value="modules">
          <AdminModulesPage />
        </TabsContent>
      </Tabs>
    </div>
  );
}
